import { mapState, mapGetters, mapMutations, mapActions } from 'vuex'
import validationMixinGeneral from '@apps/order-form/src/mixins/validationMixinGeneral'
// import date from '@apps/order-form/src/mixins/date'
import { helpers } from '@vuelidate/validators'
import { GENERAL_STORE } from '../store'

export default {
  props: {
    dot: Object,
  },
  mixins: [validationMixinGeneral /* date */],

  validations() {
    return {
      timeTo: {
        isEnoughTime: helpers.withMessage(
          'Не успеть, нужно больше времени',
          () => this.dot.isEnoughTime
        ),
        // Для формы получателя проверяем, не выставлено ли дефолтное значение "Выбрать" в поле "До"
        notDefault: helpers.withMessage(
          'Укажите время, до которого должен прибыть курьер',
          timeTo => (this.isLastDot ? timeTo !== '23:59' : true)
        ),
      },
    }
  },

  watch: {
    availableTimes(newVal) {
      // if (!newVal.length) {
      //   console.log(this.availableDates)
      //   this.date = this.availableDates[1].value
      // }

      // Если не найдено новое значение в массиве доступных, то указываем последнее из них
      if (!newVal.find(time => time.value === this.timeTo)) {
        this.updateDot({
          dot: this.dot,
          data: {
            key: 'timeTo',
            value: this.form.allTimes.at(-2).value,
          },
        })
        this.calculatePrice()
      }
    },
    'dot.isEnoughTime': {
      handler() {
        this.touchField('timeTo')
      },
    },
  },
  computed: {
    ...mapState(GENERAL_STORE, ['base', 'form', 'order', 'currentDate']),
    ...mapGetters(GENERAL_STORE, ['getDotIndex', 'minTimePickup', 'minTimeDelivery']),

    timeTo: {
      get() {
        return this.dot.timeTo
      },
      set(value, oldVal) {
        this.updateDot({ dot: this.dot, data: { key: 'timeTo', value } })
        if (oldVal && value === this.currentDate.time) return

        this.calculatePrice()
      },
    },
    isLastDot() {
      return this.getDotIndex(this.dot) === this.order.dots.length - 1
    },
    isPickUpDot() {
      return this.getDotIndex(this.dot) === 0
    },
    isToday() {
      return this.dot.date === this.currentDate.clearedDate
    },
    thisDotIndex() {
      return this.getDotIndex(this.dot)
    },
    isEdit() {
      return this.base.isEdit
    },
    availableTimes() {
      // Исключаем "Неважно", равное 00:00
      let times = this.form.allTimes.filter(time => time.value > '00:00')

      // Для админов возвращаем полный пул времен
      if (this.base.isAdmin) return times

      // Минимальное время - время от текущей точки
      let minimalTimeToChoose = this.dot.timeFrom

      // Если это точка забора и заказ на сегодня. Описание значения и для чего находится в геттере
      if (this.isPickUpDot && this.isToday)
        minimalTimeToChoose =
          this.minTimePickup > minimalTimeToChoose ? this.minTimePickup : minimalTimeToChoose
      // Если это точка доставки и заказ на сегодня. Описание значения и для чего так же находится в геттере
      if (!this.isPickUpDot && this.isToday)
        minimalTimeToChoose =
          this.minTimeDelivery > minimalTimeToChoose ? this.minTimeDelivery : minimalTimeToChoose

      // Итериируемся по всем точкам в заказе
      this.order.dots.forEach(comparingDot => {
        //   // Проверяемая точка стоит после текущей? (или является ею)
        const isAfterCurrentOne = this.getDotIndex(comparingDot) >= this.thisDotIndex
        //   // У проверяемой точки и у текущей одинаковый день
        const isSameDay = this.dot.date === comparingDot.date

        // Задача: https://tracker.yandex.ru/FRONTEND-1035
        // Если проверяемая точка до текущей и день тот же, то увеличиваем минимальное значение на час от предыдущей точки
        // То есть если у предыдущей точки время до 13:30, то у этой должно быть как минимум 14:30
        // Так же на время до 23:00, позже - следующий день, так же описано в указанной выше задаче
        //   if (!isAfterCurrentOne && isSameDay && comparingDot.timeTo <= '23:00') {
        //     const comparingDotTimeIndex = times.findIndex(time => time.value === comparingDot.timeTo)
        //
        //     if (!comparingDotTimeIndex) return
        //     // Увеличиваем минимальное время на 30 минут, в фильтрации далее выберется следующее значение, то есть будет на час больше
        //     minimalTimeToChoose = times[comparingDotTimeIndex + 1].value
        //   }

        if (!isAfterCurrentOne && isSameDay) {
          minimalTimeToChoose = (() => {
            const byTimeTo = comparingDot.timeTo !== '23:59'

            const comparingTimeIdx = times.findIndex(time =>
              byTimeTo ? time.value === comparingDot.timeTo : time.value === comparingDot.timeFrom
            )

            if (comparingTimeIdx === -1) return minimalTimeToChoose

            const comparingTime = byTimeTo
              ? times[comparingTimeIdx - 1].value
              : times[comparingTimeIdx].value

            if (comparingTime > minimalTimeToChoose) return comparingTime

            return minimalTimeToChoose
          })()
        }
      })

      // Фильтруем по полученному минимальному значению
      times = times.filter(time => {
        if (minimalTimeToChoose === '00:00' && time.value === minimalTimeToChoose) return true
        return time.value > minimalTimeToChoose
      })

      // Одна из точек имеет изменения
      const someDotHasChanges = this.order.dots.some(
        comparingDot =>
          comparingDot.initialTimeTo !== comparingDot.timeTo ||
          comparingDot.initialTimeFrom !== comparingDot.timeFrom
      )

      // initial значения имеются у точек только при редактировании заказа
      // если есть изначальное время у точки и день у точки остался изничальным
      // и при этом не находим это время "до" в списке достпуных - добавляем в список изначальное значение
      // и ни в одной из точек нет изменений по времени
      if (
        this.dot.initialTimeTo &&
        this.dot.date === this.dot.initialDate &&
        !times.find(time => time.value === this.dot.initialTimeTo) &&
        !someDotHasChanges
      ) {
        times.unshift({
          value: this.dot.initialTimeTo,
          label: this.dot.initialTimeTo,
        })
      }

      // Для последней точки меняем "Неважно" на "Выбрать"
      if (this.isLastDot) {
        times = times.filter(time => time.label !== 'Неважно')
      } else {
        times = times.filter(time => time.label !== 'Выбрать')
      }

      return times
    },
  },
  methods: {
    ...mapMutations(GENERAL_STORE, ['updateDot', 'addValidator']),
    ...mapActions(GENERAL_STORE, ['calculatePrice']),
  },

  mounted() {
    this.addFieldValidator('timeTo', this.$refs.timeTo.$refs.timeToField.timeField)
  },
}
